import type { Common, MstCommon } from '@libs/domain';

class LocationMstSetting
  implements Pick<MstCommon['schema'], 'codeDigits' | 'displayName'>, Pick<Common['schema'], 'isUsed'>
{
  private constructor(
    readonly isUsed: boolean,
    readonly displayName: string,
    readonly codeDigits: string,
  ) {}

  static fromRaw(raw: LocationMstSettingRaw) {
    return new LocationMstSetting(raw.isUsed, raw.displayName, raw.codeDigits);
  }
}

class LocationMstSettingRaw
  implements Pick<MstCommon['record'], 'codeDigits' | 'displayName'>, Pick<Common['record'], 'isUsed'>
{
  private constructor(
    readonly isUsed: boolean,
    readonly displayName: string,
    readonly codeDigits: string,
  ) {}

  static fromModel(model: LocationMstSetting, defaultName: string) {
    return new LocationMstSettingRaw(
      model.isUsed,
      model.isUsed ? model.displayName : model.displayName ? model.displayName : defaultName,
      model.isUsed ? model.codeDigits : model.codeDigits ? model.codeDigits : '10',
    );
  }
}

export { LocationMstSetting, LocationMstSettingRaw };
